import $ from 'jquery';
import debounce from 'lodash.debounce';

const pageLinksInit = (index, component) => {
    const $component = $(component);
    const $pageLinkContainer = $component.find('.page-links');
    // const $pageLinkItem = $component.find('li');
    const $mobileTrigger = $component.find('.mobile-trigger');
    let lastScrollPosition = 0;
    const pageLinks = $('.s-page-links');
    const position = pageLinks.offset().top;
    const isDesktop = 1024;
    const mobileHeader = $('.s-mobile-header');

    $pageLinkContainer.removeAttr('style');

    $mobileTrigger.on('click', function (e) {
        e.preventDefault();

        const $trigger = $(this);
        $trigger.parent('section').toggleClass('active');
    });

    $pageLinkContainer.on('click', 'a', () => {
        pageLinks.removeClass('animate').removeClass('active');
    });

    const stickyPageLinks = () => {
        const isMobile = $(window).width() < isDesktop;
        if (isMobile) {
            if ($(window).scrollTop() >= position - 48) {
                pageLinks.addClass('sticky');
                let topValue = '';
                if (pageLinks.hasClass('animate')) {
                    topValue = mobileHeader.length ? '48px' : '0px';
                }
                pageLinks.css('top', topValue);
            } else {
                pageLinks.removeClass('sticky');
                pageLinks.css('top', '');
            }
        } else if ($(window).width() > isDesktop) {
            if ($(window).scrollTop() >= position) {
                pageLinks.addClass('sticky');
            } else {
                pageLinks.removeClass('sticky');
            }
            pageLinks.css('top', '');
        }
    };

    const animatePageLinks = () => {
        const scrollPosition = $(window).scrollTop();
        if (scrollPosition > lastScrollPosition) {
            pageLinks.removeClass('animate').removeClass('active');
        } else {
            pageLinks.addClass('animate');
        }
        lastScrollPosition = scrollPosition;
    };

    // Debounced resize handler using lodash
    const handleResize = debounce(() => {
        stickyPageLinks();
    }, 200);

    $(window).on('scroll', () => {
        stickyPageLinks();
        animatePageLinks();
    });

    $(window).on('resize', handleResize);
};

const animateAnchor = () => {
    $('body').on('click', 'a[href*="#"]', function (e) {
        // global anchor link
        const $el = $(this);
        const linkID = $el.attr('href');
        const $target = $(`[data-id="${linkID}"]`);

        // if anchor is page link
        const $pageLink = $el.closest('.s-page-links');
        const $pageLinkItem = $pageLink.find('li');

        if ($pageLink.length > 0 && $pageLinkItem.length > 0) {
            $pageLinkItem.removeClass('active');
            $el.parent('li').addClass('active');
        }

        if ($target.length <= 0) return;

        e.preventDefault();

        $('html, body').animate({ scrollTop: $target.offset().top }, 100);
    });
};

$(() => {
    const $section = $('.s-page-links');

    if ($section.length) {
        $section.each(pageLinksInit);
    }

    animateAnchor();
});
